import { GenericApiErrors } from 'src/features/fraction/FractionTypes'
import { parseFailedResponse, parseGoodResponse } from 'src/infrastructure/parse-axios-response'
import { GetInvoiceParams, InvoiceTypes } from './danfeTypes'
import http from 'src/infrastructure/http'

interface getDanfeHttpResponse {
  danfeHtml: string
}

export const getDanfe = async ({ invoiceKey, type, onError }: GetInvoiceParams) => {
  const resource = type === InvoiceTypes.RECEIVEMENT ? 'invoice-nfe' : 'nfe'

  try {
    const result = await http.get<getDanfeHttpResponse>(
      `/v2/recebimento/danfe/${resource}/${invoiceKey}`,
    )

    return parseGoodResponse<string>(result.data.danfeHtml)
  } catch (error: any) {
    if (onError) onError()
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, error.response)
  }
}
